import { Typography } from "@mui/material";

export default function AutomatedMessageInfo() {
  return (
    <Typography
      variant="paragraphSmall"
      sx={{
        color: "secondary.main",
        mt: 2,
      }}
    >
      By creating this appointment, you acknowledge you will receive automated
      transactional messages from this merchant.
    </Typography>
  );
}
